import React, { useLayoutEffect, useRef } from 'react';
import { useAtom } from 'jotai';
import { makeStyles } from '@material-ui/styles';
import { Skeleton } from '@material-ui/lab';
import { MDSTable, MDSTableBody, MDSTableCell, MDSTableHead, MDSTableRow } from '@marqvision/mds/core';
import { ClientRequestProtocolGetCrListResponseCR } from '~/swagger/data-contracts';
import { requestScrollTarget } from '../@atoms';
import { ListTableColgroup } from './@components/ListTableColgroup';
import { ListTableRow } from './@components/ListTableRow';

const useStyles = makeStyles({
  table: {
    overflow: 'auto',
  },
});

type Props = {
  onViewDetail: (target: number) => void;
  isLoading: boolean;
  data: ClientRequestProtocolGetCrListResponseCR[];
  viewMoreBox: React.ReactElement;
};

export const ListTable = (props: Props) => {
  const { isLoading, data, onViewDetail, viewMoreBox } = props;
  const classes = useStyles();

  const scrollBoxRef = useRef<HTMLDivElement>(null);
  const [scrollTarget, setScrollTarget] = useAtom(requestScrollTarget);

  const handleViewDetail = (target: number) => () => {
    const currentScrollTop = scrollBoxRef.current?.scrollTop || 0;
    setScrollTarget(currentScrollTop);
    onViewDetail(target);
  };

  useLayoutEffect(() => {
    scrollBoxRef.current?.scrollTo({ top: scrollTarget });
  }, []);

  return (
    <div className={classes.table} ref={scrollBoxRef}>
      <MDSTable>
        <ListTableColgroup />
        <MDSTableHead isStickyHeader>
          <MDSTableRow>
            <MDSTableCell>
              ID
            </MDSTableCell>
            <MDSTableCell>
              Type
            </MDSTableCell>
            <MDSTableCell>
              Status
            </MDSTableCell>
            <MDSTableCell>
              Requested date
            </MDSTableCell>
          </MDSTableRow>
        </MDSTableHead>
        <MDSTableBody>
          {isLoading ? (
            [...Array(5)].map((_, index) => (
              <MDSTableRow key={`row${index}`}>
                {[...Array(4)].map((_, index) => (
                  <MDSTableCell key={`cell${index}`}>
                    <Skeleton />
                  </MDSTableCell>
                ))}
              </MDSTableRow>
            ))
          ) : !data.length ? (
            <MDSTableRow>
              <MDSTableCell colSpan={4} align="center">
                No requests yet.
              </MDSTableCell>
            </MDSTableRow>
          ) : data.map((item) => (
            <ListTableRow
              key={item.dbId}
              data={item}
              onClick={handleViewDetail(item.dbId)}
            />
          ))}
        </MDSTableBody>
      </MDSTable>
      {viewMoreBox}
    </div>
  );
};